module.exports = __webpack_public_path__ + "static/media/bold.298f1800.svg";